var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.25H11.5M16.4342 12.979C16.1358 12.5024 15.9775 11.9514 15.9772 11.389V7.22505C15.9772 5.50724 15.2948 3.85979 14.0801 2.64512C12.8654 1.43044 11.218 0.748047 9.50017 0.748047C7.78237 0.748047 6.13492 1.43044 4.92024 2.64512C3.70557 3.85979 3.02317 5.50724 3.02317 7.22505V11.387C3.02325 11.9501 2.86488 12.5018 2.56617 12.979L1.47817 14.719C1.38357 14.8704 1.3312 15.0444 1.32652 15.2228C1.32183 15.4012 1.365 15.5777 1.45153 15.7338C1.53806 15.8899 1.66481 16.0201 1.81861 16.1107C1.97242 16.2013 2.14767 16.249 2.32617 16.249H16.6742C16.8527 16.249 17.0279 16.2013 17.1817 16.1107C17.3355 16.0201 17.4623 15.8899 17.5488 15.7338C17.6354 15.5777 17.6785 15.4012 17.6738 15.2228C17.6691 15.0444 17.6168 14.8704 17.5222 14.719L16.4342 12.979Z",
    stroke: "#4628FF",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.682e93dc9429c2bfb5463a87c885f42c.svg";
export { ForwardRef as ReactComponent };